
// @ts-nocheck


export const localeCodes =  [
  "en",
  "lv",
  "lt",
  "de",
  "et",
  "fi",
  "ru",
  "uk"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.json", load: () => import("../locales/en.json" /* webpackChunkName: "locale__builds_common_airbaltic_com_bt_frontend_nuxt_locales_en_json" */), cache: true }],
  "lv": [{ key: "../locales/lv.json", load: () => import("../locales/lv.json" /* webpackChunkName: "locale__builds_common_airbaltic_com_bt_frontend_nuxt_locales_lv_json" */), cache: true }],
  "lt": [{ key: "../locales/lt.json", load: () => import("../locales/lt.json" /* webpackChunkName: "locale__builds_common_airbaltic_com_bt_frontend_nuxt_locales_lt_json" */), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => import("../locales/de.json" /* webpackChunkName: "locale__builds_common_airbaltic_com_bt_frontend_nuxt_locales_de_json" */), cache: true }],
  "et": [{ key: "../locales/et.json", load: () => import("../locales/et.json" /* webpackChunkName: "locale__builds_common_airbaltic_com_bt_frontend_nuxt_locales_et_json" */), cache: true }],
  "fi": [{ key: "../locales/fi.json", load: () => import("../locales/fi.json" /* webpackChunkName: "locale__builds_common_airbaltic_com_bt_frontend_nuxt_locales_fi_json" */), cache: true }],
  "ru": [{ key: "../locales/ru.json", load: () => import("../locales/ru.json" /* webpackChunkName: "locale__builds_common_airbaltic_com_bt_frontend_nuxt_locales_ru_json" */), cache: true }],
  "uk": [{ key: "../locales/uk.json", load: () => import("../locales/uk.json" /* webpackChunkName: "locale__builds_common_airbaltic_com_bt_frontend_nuxt_locales_uk_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "./server/utils/localeDetector.ts",
    "switchLocalePathLinkSSR": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "iso": "en",
      "dir": "ltr",
      "label": "english",
      "files": [
        "locales/en.json"
      ]
    },
    {
      "code": "lv",
      "iso": "lv",
      "dir": "ltr",
      "label": "latvian",
      "files": [
        "locales/lv.json"
      ]
    },
    {
      "code": "lt",
      "iso": "lt",
      "dir": "ltr",
      "label": "lithuanian",
      "files": [
        "locales/lt.json"
      ]
    },
    {
      "code": "de",
      "iso": "de",
      "dir": "ltr",
      "label": "german",
      "files": [
        "locales/de.json"
      ]
    },
    {
      "code": "et",
      "iso": "et",
      "dir": "ltr",
      "label": "estonian",
      "files": [
        "locales/et.json"
      ]
    },
    {
      "code": "fi",
      "iso": "fi",
      "dir": "ltr",
      "label": "finnish",
      "files": [
        "locales/fi.json"
      ]
    },
    {
      "code": "ru",
      "iso": "ru",
      "dir": "ltr",
      "label": "russian",
      "files": [
        "locales/ru.json"
      ]
    },
    {
      "code": "uk",
      "iso": "uk",
      "dir": "ltr",
      "label": "ukranian",
      "files": [
        "locales/uk.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": true,
  "langDir": "locales/",
  "detectBrowserLanguage": {
    "alwaysRedirect": true,
    "cookieCrossOrigin": true,
    "cookieDomain": ".airbaltic.com",
    "cookieKey": "language",
    "cookieSecure": true,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "book-flight": {
      "en": "/book-flight",
      "lv": "/rezervet-biletes",
      "de": "/fluge-buchen",
      "lt": "/uzsakyti-skrydzius",
      "et": "/broneerige-lend",
      "fi": "/varaa-lennot",
      "ru": "/kupit-aviabilety",
      "uk": "/bronyujte-aviakvitki"
    },
    "manage-my-booking": {
      "en": "/manage-my-booking",
      "lv": "/mana-rezervacija",
      "de": "/buchung-verwalten",
      "lt": "/mano-uzsakymai",
      "et": "/halda-broneeringut",
      "fi": "/hallitse-varausta",
      "ru": "/upravlenie-bronirovaniem",
      "uk": "/keruvaty-bronyuvannyam"
    },
    "check-in": {
      "en": "/check-in",
      "lv": "/registresanas-lidojumam",
      "ru": "/registraciya-na-rejs",
      "et": "/lennule-registreerimine",
      "lt": "/registracija-skrydziui",
      "de": "/online-check-in",
      "fi": "/lahtoselvitys",
      "uk": "/online-reiestratsiia"
    },
    "index": {
      "en": "/index",
      "lv": "/index",
      "ru": "/index",
      "et": "/index",
      "lt": "/index",
      "de": "/index",
      "fi": "/index",
      "uk": "/index"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "iso": "en",
    "dir": "ltr",
    "label": "english",
    "files": [
      {
        "path": "locales/en.json"
      }
    ]
  },
  {
    "code": "lv",
    "iso": "lv",
    "dir": "ltr",
    "label": "latvian",
    "files": [
      {
        "path": "locales/lv.json"
      }
    ]
  },
  {
    "code": "lt",
    "iso": "lt",
    "dir": "ltr",
    "label": "lithuanian",
    "files": [
      {
        "path": "locales/lt.json"
      }
    ]
  },
  {
    "code": "de",
    "iso": "de",
    "dir": "ltr",
    "label": "german",
    "files": [
      {
        "path": "locales/de.json"
      }
    ]
  },
  {
    "code": "et",
    "iso": "et",
    "dir": "ltr",
    "label": "estonian",
    "files": [
      {
        "path": "locales/et.json"
      }
    ]
  },
  {
    "code": "fi",
    "iso": "fi",
    "dir": "ltr",
    "label": "finnish",
    "files": [
      {
        "path": "locales/fi.json"
      }
    ]
  },
  {
    "code": "ru",
    "iso": "ru",
    "dir": "ltr",
    "label": "russian",
    "files": [
      {
        "path": "locales/ru.json"
      }
    ]
  },
  {
    "code": "uk",
    "iso": "uk",
    "dir": "ltr",
    "label": "ukranian",
    "files": [
      {
        "path": "locales/uk.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
